/* istanbul ignore file */
import { useState } from 'react';
import { Button } from 'framework/ui/mui-builder';
import { Modal, EditButtonProps } from 'framework/ui/ui-builder';
import SetVacancyManagerForm from 'domain/recruiting/vacancy/shared/input/SetVacancyManagerForm';
import { useAuthorization } from 'framework/authorization';

const EditVacancyManagerButton = ({ permissionToCheck, ...props }: EditButtonProps) => {
  const [modalOpen, setModalOpen] = useState(false);

  const closeModal = () => {
    setModalOpen(false);
  };

  const openModal = () => {
    setModalOpen(true);
  };

  const { isGranted } = useAuthorization();

  if (permissionToCheck && !isGranted(permissionToCheck)) {
    return null;
  }

  return (
    <>
      <Button {...props} onClick={openModal}>
        Assign
      </Button>

      <Modal backdrop="static" isOpen={modalOpen} onToggle={closeModal} title="Set vacancy manager" hasCancelButton>
        <SetVacancyManagerForm closeModal={closeModal} modalOpen={modalOpen} />
      </Modal>
    </>
  );
};

export default EditVacancyManagerButton;
